module.exports = __webpack_public_path__ + "static/media/chs_1.e269ec05.png";